import { useState, useEffect } from "react";
import { Table, Tab, Tabs } from "react-bootstrap";
import { useFormik } from "formik";
import dayjs from "dayjs";
import es from "dayjs/locale/es";
import SelectPicker from 'rsuite/SelectPicker';
import 'rsuite/SelectPicker/styles/index.css';
import { axiosInstance } from "../../components/helpers/axiosInstance";

/**
 * COMPONENTE PRINCIPAL
 * @returns {JSX.Element}
 * @constructor
 */
export default function Resumen() {
    /**
     * Almacena los datos de resumen
     */
    const [resumen, setResumen] = useState([]);
    const { cajas } = JSON.parse(sessionStorage.getItem('user'));
    /**
     * Valor inicial de la caja
     * @type {{caja}}
     */
    const valorInicial = {
        caja : cajas[0]?.id_caja ?? ""
    }
    /**
     * @function onSubmit
     * @param values
     */
    function onSubmit(values) {
        console.log(values);
    }
    /**
     * Constantes de Formik : manejo del formulario
     */
    const formik = useFormik({
        initialValues : valorInicial,
        onSubmit
    });
    /**
     * Se hace la petición al servidor cuando cambia la caja
     */
    useEffect(() => {
             axiosInstance.get("/cajas/" + formik.values.caja + "/resumen").then((res) => {
                //Guardar datos
                setResumen(res.data.toReversed());
            }).catch((error) => console.log(error));
    }, [formik.values.caja]);
    /**
     * Fechas
     */
    dayjs.locale(es);

    return (
        <>
            <style type='text/css'>
                {`
                    @media (max-width: 767.98px) {
                        .nav-tabs-fiducia .nav-item .nav-link i:before {
                            margin-top: -8px!important;
                        }
                        .nav-tabs-fiducia .nav-item .nav-link span:before {
                            margin-top: -8px!important;
                        }
                    }

                    .nav-tabs-fiducia {
                        position : sticky;
                        top : 5.769230769rem;
                        z-index : 7;
                    }
                    
                    @media (max-width: 991.98px) {
                        .nav-tabs-fiducia {
                            position : sticky;
                            top : 4.615384615rem;
                            z-index : 7;
                        }
                    }
                    
                    .nav-tabs.nav-tabs-fiducia .nav-item .nav-link.active span#caja-describe:before {
                        display: none!important;
                    }
                    .nav-tabs.nav-tabs-fiducia .nav-item .nav-link.active span#caja-describe:after {
                        display: none!important;
                    }
                    
                    .nav-link #caja{
                        padding: 0 15px!important;
                    }
                    
                    #caja .rs-picker-toggle-indicator .rs-picker-caret-icon, .rs-picker-toggle.rs-btn .rs-picker-toggle-indicator .rs-picker-clean{
                        top:0!important;
                        right:0!important;
                    } 
                    
                    #caja:hover{
                        background-color: transparent!important;
                    }
                    
                    #caja:focus{
                        background-color: transparent!important;
                    }
                    
                    .rs-picker-subtle #caja:active{
                        background-color: transparent!important;
                    }
                `}
            </style>
            <Tabs
                className={'nav-tabs-fiducia'}
                defaultActiveKey={'home'}
                transition={false}
            >
                <Tab
                    id={'select_caja'}
                    title={<>
                        <SelectPicker
                            appearance={'subtle'}
                            data={cajas}
                            style={{width: "100%"}}
                            menuStyle={{width: 'auto'}}
                            menuAutoWidth={false}
                            id={'caja'}
                            name={'caja'}
                            labelKey={'caja'}
                            valueKey={'id_caja'}
                            value={formik.values.caja}
                            onChange={(value) => formik.setFieldValue('caja', value)}
                            onBlur={formik.handleBlur}
                            searchable={false}
                            cleanable={false}
                            disabled={cajas.length === 0}
                        />
                    <span></span>
                </>} eventKey="home">
                    {
                        cajas && cajas.length > 0 ? (
                            <TablaResumen resumen={resumen}></TablaResumen>
                        ) : (
                            <div className={"position-relative"} style={{height: "10rem"}}>
                                <div className={"position-absolute top-50 start-50 translate-middle"}>
                                    <i className="ki-duotone ki-search-list fs-5hx text-primary">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                        <span className="path3"></span>
                                    </i>
                                </div>
                                <br/>
                                <span className={"position-absolute bottom-0 start-50 translate-middle-x fw-semibold fs-5"}>Sin datos</span>
                            </div>
                        )
                    }
                </Tab>
            </Tabs>
        </>
    );
}
function TablaResumen({resumen}){
    return(
        <>
            {
                /**
                 * ESTILOS DE TABLA
                 */
            }
            <style type="text/css">
                {`
                .text-efectivo{
                    color: #77933C!important;
                }

                .text-banco{
                    color: #E46C0A!important;
                }

                .rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value{
                        color : var(--bs-gray-700)!important;
                }
                
                .tabla-hover > tbody > tr:hover{
                    background-color: #4F6228!important;
                }
                
            `}
            </style>
            {
                /**
                 * FIN: ESTILOS DE TABLA
                 */
            }
            {
                /**
                 * TABLA DE RESUMEN
                 */
            }
            <Table responsive className="table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4" id={'resumen-corte'}>
                {
                    /**
                     * INICIA : HEADER
                     */
                }
                <thead className="fw-bold text-muted pb-5 text-uppercase">
                    <tr className={'text-start'}>
                        <th colSpan={1}></th>
                        {
                            resumen && resumen.map((r, index) => <th key={index} className={'pb-5'}>{dayjs(r.fecha).format('DD MMM')}</th>)
                        }
                    </tr>
                </thead>
                {
                    /**
                     * FIN : HEADER
                     */
                }
                {
                    /**
                     * INICIA : DATOS
                     */
                }
                <tbody className="">
                    <tr className="text-uppercase pe-none" style={{color: "#3471a1"}}>
                        <td className="fw-bold ps-11">Saldo inicial en caja</td>
                        {
                            /**
                             * @param r.e_ini
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="fw-bolder">{r.e_ini}</td>
                            ))
                        }
                    </tr>
                    <tr className={"pe-none"} style={{backgroundColor: "#4F6228"}}>
                        <th colSpan={16} className="text-uppercase text-white fw-bold ps-11">Ingreso Efectivo</th>
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end fw-bold pe-5 text-efectivo">Consultas</td>
                        {
                            /**
                             * @param r.bsq_ef
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="bg-consulta-data">{r.bsq_ef}</td>
                            ))
                        }
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end fw-bold pe-5 text-efectivo">Contrataciones</td>
                        {
                            /**
                             * @param r.cnt_ef
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="bg-consulta-data">{r.cnt_ef}</td>
                            ))
                        }
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end  fw-bold pe-5 text-efectivo">Pago de servicios</td>
                        {
                            /**
                             * @param r.srv_ef
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="bg-consulta-data">{r.srv_ef}</td>
                            ))
                        }
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end  fw-bold pe-5 text-efectivo">Otros efectivo</td>
                        {
                            /**
                             * @param r.otr_ef
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="bg-consulta-data">{r.otr_ef}</td>
                            ))
                        }
                    </tr>
                    <tr className={"pe-none"} style={{backgroundColor : "#984807"}}>
                        <th colSpan={16} className="text-uppercase text-white fw-bold ps-11">TD/TC/CHQ…</th>
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end text-banco fw-bold pe-5">Consultas</td>
                        {
                            /**
                             * @param r.bsq_om
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="bg-data-om">{r.bsq_om}</td>
                            ))
                        }
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end text-banco fw-bold pe-5">Contrataciones</td>
                        {
                            /**
                             * @param r.cnt_om
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="bg-data-om">{r.cnt_om}</td>
                            ))
                        }
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end text-banco fw-bold pe-5">Pago de servicios</td>
                        {
                            /**
                             * @param r.srv_om
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="bg-data-om">{r.srv_om}</td>
                            ))
                        }
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end text-banco fw-bold pe-5">OTROS TD/TC/CHQ…</td>
                        {
                            /**
                             * @param r.otr_om
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="bg-data-om">{r.otr_om}</td>
                            ))
                        }
                    </tr>
                    <tr className={'pe-none'} style={{backgroundColor : "#413152"}}>
                        <th colSpan={16} className="text-uppercase text-white fw-bold ps-11">total</th>
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end  fw-bold pe-5" style={{color: "#604A7B"}}>Ingresos en efectivo</td>
                        {
                            /**
                             * @param r.ing_ef
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index}>{r.ing_ef}</td>
                            ))
                        }
                    </tr>
                    <tr>
                        <td className="text-uppercase text-end  fw-bold pe-5" style={{color: "#604A7B"}}>Ingresos otros tdc/chq</td>
                        {
                            /**
                             * @param r.ing_om
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} >{r.ing_om}</td>
                            ))
                        }
                    </tr>
                    <tr className={'pe-none'} style={{color: "#403152"}}>
                        <td className="text-uppercase fw-bold ps-11">Bruto</td>
                        {
                            /**
                             * @param r.ing_brt
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className=" fw-bolder">{r.ing_brt}</td>
                            ))
                        }
                    </tr>
                    <tr className={"pe-none"} style={{ color: "#622523"}}>
                        <td className="text-uppercase fw-bold ps-11">Gastos</td>
                        {
                            /**
                             * @param r.gst
                             */
                            resumen && resumen.map((r, index) => (
                                <td key={index} className={"fw-bolder"}>{r.gst}</td>
                            ))
                        }
                    </tr>
                    <tr className={'pe-none'} style={{color: "#262626"}}>
                        <td className="text-uppercase fw-bold ps-11">Efectivo real en caja</td>
                        {
                            resumen && resumen.map((r, index) => (
                                <td key={index} className={"fw-bolder " + (r.corte === r.total ? "text-black" : r.corte < r.total ? "text-danger" : "text-primary")}>{r.corte}</td>
                            ))
                        }
                    </tr>
                    <tr className={'pe-none'} style={{color: "#262626"}}>
                        <td className="text-uppercase fw-bold ps-11">Diferencia del total y efectivo en caja</td>
                        {
                            resumen && resumen.map((r, index) => (
                                <td key={index} className="fw-bolder">{
                                    r.total === null ||  r.corte === null ? r.total ?? r.corte : `$ ${parseInt(r.total.replace(/[,$]/g,'')) - parseInt(r.corte.replace(/[,$]/g,''))}`
                                }</td>
                            ))
                        }
                    </tr>
                </tbody>
                {
                    /**
                     * DATOS
                     * */
                }
            </Table>
        </>
    );
}

